import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../redux/reducers/utils";
import { const_var, params } from "../../redux/reducers/reducer";
import setPricingDataForLeanto from "./setPricingDataForLeanto.helper";
import { LEAN_TYPE_NUM_TO_STR } from "../../Constants/constant";
import { checkRoofPitch } from "../building/building_config/building.helper";
import { onForceLeantoRemoval } from "./lean_building_wall/leanBuildingWall.helper";
export const setDefaultLeanToData = (const_var, state, params, upperCaseFirst) => {
	let newLeanArray = [];
	if (
		const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != undefined &&
		const_var.defaultBuildingArr[state.defaultBuilding].leanto_data != null &&
		Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data).length > 0
	) {
		const_var.leantofront = {};
		const_var.leantoback = {};
		for (let leanData in const_var.defaultBuildingArr[state.defaultBuilding].leanto_data) {
			if (Object.keys(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data[leanData]).length > 0) {
				if (leanData == "left") {
					const_var.leantoleft.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].size.split("x")[0]);
					const_var.leantoleft.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].size.split("x")[1]);
					const_var.leantoleft.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].size.split("x")[2]);
					const_var.leantoleft.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.front_wall;
					const_var.leantoleft.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.back_wall;
					const_var.leantoleft.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.side_wall;
					params.p_b_c_b_l_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.front_wall)
							: params.p_b_c_b_l_f;
					params.p_b_c_b_l_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.back_wall)
							: params.p_b_c_b_l_b;
					params.p_b_c_b_l =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.side_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].wall.side_wall)
							: params.p_b_c_b_l;

					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch] =
							const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["left"].roof_pitch.split("/")[0];
					}
					const_var.newLeanArr["left"] = const_var.leantoleft;
					params.ShowLeanRecord = true;
				}
				if (leanData == "gable_left") {
					const_var.leantoleft.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].size.split("x")[0]);
					const_var.leantoleft.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].size.split("x")[1]);
					const_var.leantoleft.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].size.split("x")[2]);
					const_var.leantoleft.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.front_wall;
					const_var.leantoleft.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.back_wall;
					const_var.leantoleft.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.left_side;
					const_var.leantoleft.right_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.right_side;
					params.p_b_c_b_l_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.front_wall)
							: params.p_b_c_b_l_f;
					params.p_b_c_b_l_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.back_wall)
							: params.p_b_c_b_l_b;
					params.p_b_c_b_l_r =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.right_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.right_side)
							: params.p_b_c_b_l_r;
					params.p_b_c_b_l =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.left_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].wall.left_side)
							: params.p_b_c_b_l;

					if (
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].roof_pitch != undefined &&
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].roof_pitch != null
					) {
						params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_left"].roof_pitch.split("/")[0];
					}
					const_var.newLeanArr["gable_left"] = const_var.leantoleft;
					params.ShowLeanRecord = true;
				}
				if (leanData == "right") {
					const_var.leantoright.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].size.split("x")[0]);
					const_var.leantoright.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].size.split("x")[1]);
					const_var.leantoright.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].size.split("x")[2]);
					const_var.leantoright.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.front_wall;
					const_var.leantoright.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.back_wall;
					const_var.leantoright.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.side_wall;
					params.p_b_c_b_r_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.front_wall)
							: params.p_b_c_b_r_f;
					params.p_b_c_b_r_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.back_wall)
							: params.p_b_c_b_r_b;
					params.p_b_c_b_r =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.side_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].wall.side_wall)
							: params.p_b_c_b_r;

					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch] =
							const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["right"].roof_pitch.split("/")[0];
					}

					const_var.newLeanArr["right"] = const_var.leantoright;
					params.ShowLeanRecord = true;
				}
				if (leanData == "gable_right") {
					const_var.leantoright.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].size.split("x")[0]);
					const_var.leantoright.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].size.split("x")[1]);
					const_var.leantoright.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].size.split("x")[2]);
					const_var.leantoright.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.front_wall;
					const_var.leantoright.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.back_wall;
					const_var.leantoright.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.left_side;
					const_var.leantoright.right_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.right_side;
					params.p_b_c_b_r_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.front_wall)
							: params.p_b_c_b_r_f;
					params.p_b_c_b_r_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.back_wall)
							: params.p_b_c_b_r_b;
					params.p_b_c_b_r =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.right_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.right_side)
							: params.p_b_c_b_r;
					params.p_b_c_b_r_r =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.left_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].wall.left_side)
							: params.p_b_c_b_r_r;

					if (
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].roof_pitch != undefined &&
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].roof_pitch != null
					) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_right"].roof_pitch.split("/")[0];
					}

					const_var.newLeanArr["gable_right"] = const_var.leantoright;
					params.ShowLeanRecord = true;
				}
				if (leanData == "front") {
					const_var.leantofront.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].size.split("x")[0]);
					const_var.leantofront.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].size.split("x")[1]);
					const_var.leantofront.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].size.split("x")[2]);
					const_var.leantofront.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.front_wall;
					const_var.leantofront.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.back_wall;
					const_var.leantofront.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.side_wall;
					params.p_b_c_b_f_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.front_wall)
							: params.p_b_c_b_f_f;
					params.p_b_c_b_f_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.back_wall)
							: params.p_b_c_b_f_b;
					params.p_b_c_b_f_l =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.side_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].wall.side_wall)
							: params.p_b_c_b_f_l;

					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pF = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch] =
							const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["front"].roof_pitch.split("/")[0];
					}

					const_var.leantofront.leanto_type = 3;
					const_var.newLeanArr["front"] = const_var.leantofront;
					params.ShowLeanRecord = true;
				}
				if (leanData == "gable_front") {
					const_var.leantofront.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].size.split("x")[0]);
					const_var.leantofront.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].size.split("x")[1]);
					const_var.leantofront.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].size.split("x")[2]);
					const_var.leantofront.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.front_wall;
					const_var.leantofront.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.back_wall;
					const_var.leantofront.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.left_side;
					const_var.leantofront.right_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.right_side;
					params.p_b_c_b_f_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.front_wall)
							: params.p_b_c_b_f_f;
					params.p_b_c_b_f_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.back_wall)
							: params.p_b_c_b_f_b;
					params.p_b_c_b_f_r =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.right_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.right_side)
							: params.p_b_c_b_f_r;
					params.p_b_c_b_f_l =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.left_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].wall.left_side)
							: params.p_b_c_b_f_l;

					if (
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].roof_pitch != undefined &&
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].roof_pitch != null
					) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pF = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_front"].roof_pitch.split("/")[0];
					}
					const_var.leantofront.leanto_type = 3;
					const_var.newLeanArr["gable_front"] = const_var.leantofront;
					params.ShowLeanRecord = true;
				}
				if (leanData == "back") {
					const_var.leantoback.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].size.split("x")[0]);
					const_var.leantoback.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].size.split("x")[1]);
					const_var.leantoback.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].size.split("x")[2]);
					const_var.leantoback.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.front_wall;
					const_var.leantoback.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.back_wall;
					const_var.leantoback.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.side_wall;
					params.p_b_c_b_b_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.front_wall)
							: params.p_b_c_b_b_f;
					params.p_b_c_b_b_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.back_wall)
							: params.p_b_c_b_b_b;
					params.p_b_c_b_b_l =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.side_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].wall.side_wall)
							: params.p_b_c_b_b_l;
					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pB = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch] =
							const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["back"].roof_pitch.split("/")[0];
					}

					const_var.leantoback.leanto_type = 4;
					const_var.newLeanArr["back"] = const_var.leantoback;
					params.ShowLeanRecord = true;
				}
				if (leanData == "gable_back") {
					const_var.leantoback.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].size.split("x")[0]);
					const_var.leantoback.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].size.split("x")[1]);
					const_var.leantoback.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].size.split("x")[2]);
					const_var.leantoback.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.front_wall;
					const_var.leantoback.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.back_wall;
					const_var.leantoback.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.left_side;
					const_var.leantoback.right_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.right_side;
					params.p_b_c_b_b_f =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.front_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.front_wall)
							: params.p_b_c_b_b_f;
					params.p_b_c_b_b_b =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.back_wall != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.back_wall)
							: params.p_b_c_b_b_b;
					params.p_b_c_b_b_r =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.right_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.right_side)
							: params.p_b_c_b_b_r;
					params.p_b_c_b_b_l =
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.left_side != null
							? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].wall.left_side)
							: params.p_b_c_b_b_l;

					if (
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].roof_pitch != undefined &&
						const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].roof_pitch != null
					) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pB = const_var.defaultBuildingArr[state.defaultBuilding].leanto_data["gable_back"].roof_pitch.split("/")[0];
					}
					const_var.leantoback.leanto_type = 4;
					const_var.newLeanArr["gable_back"] = const_var.leantoback;
					params.ShowLeanRecord = true;
				}
			} else {
				const_var.newLeanArr[leanData] = undefined;
				if (const_var.defaultBuildingArr[state.defaultBuilding].leanto == "both") {
					const_var.leantoleft.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
					const_var.leantoleft.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
					const_var.leantoleft.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
					const_var.leantoleft.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoleft.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoleft.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

					const_var.leantoright.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
					const_var.leantoright.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
					const_var.leantoright.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
					const_var.leantoright.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoright.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoright.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];

						params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					}

					const_var.newLeanArr["left"] = const_var.leantoleft;
					const_var.newLeanArr["right"] = const_var.leantoright;
					params.ShowLeanRecord = true;
				} else if (const_var.defaultBuildingArr[state.defaultBuilding].leanto == "left") {
					const_var.leantoleft.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
					const_var.leantoleft.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
					const_var.leantoleft.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
					const_var.leantoleft.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoleft.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoleft.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_p = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					}
					const_var.newLeanArr["left"] = const_var.leantoleft;

					const_var.newLeanArr["right"] = undefined;
					params.ShowLeanRecord = true;
				} else if (const_var.defaultBuildingArr[state.defaultBuilding].leanto == "right") {
					const_var.leantoright.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
					const_var.leantoright.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
					const_var.leantoright.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
					const_var.leantoright.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoright.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					const_var.leantoright.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
					if (const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch != null) {
						params.isDefault_l_t_r_p = params.b_l_t_r_pR = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
						state.const_var.BuildingLRoofPitch[const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch] = const_var.defaultBuildingArr[state.defaultBuilding].leanto_roof_pitch.split("/")[0];
					}
					const_var.newLeanArr["left"] = undefined;
					const_var.newLeanArr["right"] = const_var.leantoright;
					params.ShowLeanRecord = true;
				}
			}
		}
	} else {
		const_var.newLeanArr = [];
		if (const_var.defaultBuildingArr[state.defaultBuilding].leanto == "both") {
			const_var.leantoleft.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
			const_var.leantoleft.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
			const_var.leantoleft.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
			const_var.leantoleft.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoleft.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoleft.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

			const_var.leantoright.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
			const_var.leantoright.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
			const_var.leantoright.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
			const_var.leantoright.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoright.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoright.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

			const_var.newLeanArr["left"] = const_var.leantoleft;
			const_var.newLeanArr["right"] = const_var.leantoright;
			params.ShowLeanRecord = true;
		} else if (const_var.defaultBuildingArr[state.defaultBuilding].leanto == "left") {
			const_var.leantoleft.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
			const_var.leantoleft.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
			const_var.leantoleft.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
			const_var.leantoleft.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoleft.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoleft.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

			const_var.newLeanArr["left"] = const_var.leantoleft;
			const_var.newLeanArr["right"] = undefined;
			params.ShowLeanRecord = true;
		} else if (const_var.defaultBuildingArr[state.defaultBuilding].leanto == "right") {
			const_var.leantoright.width = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[0]);
			const_var.leantoright.length = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[1]);
			const_var.leantoright.height = parseInt(const_var.defaultBuildingArr[state.defaultBuilding].leanto_size.split("x")[2]);
			const_var.leantoright.front_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoright.back_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;
			const_var.leantoright.side_wall = const_var.defaultBuildingArr[state.defaultBuilding].leanto_wall;

			const_var.newLeanArr["left"] = undefined;
			const_var.newLeanArr["right"] = const_var.leantoright;
			params.ShowLeanRecord = true;
		} else {
			const_var.newLeanArr = [];
			params.ShowLeanRecord = false;
		}
	}
	return {
		newLeanArr: const_var.newLeanArr,
		const_var,
		params,
		state
	};
};
const LEAN_CONFIG = {
	left: {
		type: "left",
		styleKey: "left",

		widthKey: "lean_p_w",
		lengthKey: "lean_p_d",
		heightKey: "lean_p_h",
		pitchKey: "b_l_t_r_p",

		addLeanKey: "add_left_lean",

		dimWidthKey: "dimensionsLeanLW",
		dimLengthKey: "dimensionsLeanLD",
		dimHeightKey: "dimensionsLeanLH",

		leanDataKey: "leanGetDataLeft",

		updateLean: () => cuBuilding.UpdateLeftLean(),

		lengthDataKey: "leftLean",

		sourceLimitKey: "p_d",

		isSide: true
	},

	right: {
		type: "right",
		styleKey: "right",

		widthKey: "leanR_p_w",
		lengthKey: "leanR_p_d",
		heightKey: "leanR_p_h",
		pitchKey: "b_l_t_r_pR",

		addLeanKey: "add_right_lean",

		dimWidthKey: "dimensionsLeanLWR",
		dimLengthKey: "dimensionsLeanLDR",
		dimHeightKey: "dimensionsLeanLHR",

		leanDataKey: "leanGetDataRight",

		updateLean: () => cuBuilding.UpdateRightLean(),

		lengthDataKey: "rightLean",

		sourceLimitKey: "p_d",

		isSide: true
	},

	front: {
		type: "front",
		styleKey: "front",

		widthKey: "leanF_p_w",
		lengthKey: "leanF_p_d",
		heightKey: "leanF_p_h",
		pitchKey: "b_l_t_r_pF",

		addLeanKey: "add_front_lean",

		dimWidthKey: "dimensionsLeanLWF",
		dimLengthKey: "dimensionsLeanLDF",
		dimHeightKey: "dimensionsLeanLHF",

		leanDataKey: "leanGetDataFront",

		updateLean: () => cuBuilding.UpdateFrontLean(),

		lengthDataKey: "frontLean",

		sourceLimitKey: "p_w",

		isSide: false
	},

	back: {
		type: "back",
		styleKey: "back",

		widthKey: "leanB_p_w",
		lengthKey: "leanB_p_d",
		heightKey: "leanB_p_h",
		pitchKey: "b_l_t_r_pB",

		addLeanKey: "add_back_lean",

		dimWidthKey: "dimensionsLeanLWB",
		dimLengthKey: "dimensionsLeanLDB",
		dimHeightKey: "dimensionsLeanLHB",

		leanDataKey: "leanGetDataBack",

		updateLean: () => cuBuilding.UpdateBackLean(),

		lengthDataKey: "backLean",

		sourceLimitKey: "p_w",

		isSide: false
	}
};
export function updateTemplateWidthCommon(type) {
	const cfg = LEAN_CONFIG[type];

	const style = params.leanStyle[cfg.styleKey];

	const width = cfg.widthKey;
	const length = cfg.lengthKey;
	const height = cfg.heightKey;
	const pitch = cfg.pitchKey;

	const dimWidth = cfg.dimWidthKey;
	const dimLength = cfg.dimLengthKey;
	const dimHeight = cfg.dimHeightKey;

	const sourceLimit = params[cfg.sourceLimitKey];

	if (params[length] >= sourceLimit) {
		const_var.lengthData[cfg.lengthDataKey].previousLength = params[length];

		params[length] = style === "gable" ? params[length] : sourceLimit;

		const_var.lengthData[cfg.lengthDataKey].length = params[length];

		// ORIGINAL LEFT/RIGHT LOGIC
		if (cfg.isSide) {
			const_var.UpdatedPriceData.connection_fee_side_changed = true;
		}
	}

	const_var[dimWidth] = [];
	const_var[dimLength] = [];
	const_var[dimHeight] = [];

	const LengthOptions = [
		{
			label: "Standard",
			options: []
		},
		{
			label: "Custom",
			options: []
		}
	];

	const WidthOptions = [
		{
			label: "Standard",
			options: []
		},
		{
			label: "Custom",
			options: []
		}
	];

	let iVal = cfg.isSide ? 21 : 12;

	let startLength = 0;
	let endLength = 0;

	let minWidth = 0;
	let maxWidth = 0;

	let minHeight = 0;
	let maxHeight = 0;

	let roofDatanew = style === "gable" && const_var[cfg.leanDataKey]?.building_structure ? const_var[cfg.leanDataKey].building_structure : const_var.roof_style_Barn;

	if (const_var.roof_style_Barn_with_centerbuilding[params.p_b_t] != undefined && style !== "gable") {
		roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
	}

	let maxGableWidth = 0;
	let minGableWidth = 0;

	let maxGableHeight = 0;
	let minGableHeight = 0;

	let maxGableLength = 0;
	let minGableLength = 0;

	if (const_var.c_m_a[params.p_b_t]?.gable_mapping?.length > 0) {
		const gable = const_var.c_m_a[params.p_b_t].gable_mapping[0];

		maxGableWidth = gable.max_width;
		minGableWidth = gable.min_width;

		maxGableHeight = gable.max_height;
		minGableHeight = gable.min_height;

		maxGableLength = gable.max_length;
		minGableLength = gable.min_length;
	}
	
   if(!Array.isArray(roofDatanew)){
        roofDatanew = [roofDatanew];
    } 
	roofDatanew?.forEach((val) => {
		if (params.p_r_s == val.roof_id) {
			iVal = style === "gable" && minGableLength != 0 ? minGableLength : cfg.isSide ? val.start_length : val.min_width;

			startLength = style === "gable" && minGableLength != 0 ? minGableLength : val.start_length;

			endLength = style === "gable" && maxGableLength != 0 ? maxGableLength : val.building_max_length;

			maxWidth = style === "gable" && maxGableWidth != 0 ? maxGableWidth : val.max_width;

			minWidth = style === "gable" && minGableWidth != 0 ? minGableWidth : val.min_width;

			maxHeight = style === "gable" && maxGableHeight != 0 ? maxGableHeight : val.max_height;

			minHeight = style === "gable" && minGableHeight != 0 ? const_var[cfg.leanDataKey]?.building_structure?.[0]?.min_height || minGableHeight : val.min_height;

			const_var.leanDimension = val;
			const_var.b_m_i_hlean = minHeight;
		}
	});

	if (maxWidth == 0) {
		maxWidth = maxGableWidth != 0 ? maxGableWidth : params.p_w;
	}

	if (endLength == 0) {
		endLength = maxGableLength != 0 ? maxGableLength : params.p_d;
	}

	if (parseInt(params[width]) < parseInt(minWidth)) {
		params[width] = minWidth;
	}

	if (sourceLimit < startLength) {
		startLength = sourceLimit;
	}

	const newDataLength = cfg.isSide ? (style === "gable" ? endLength : sourceLimit <= endLength ? sourceLimit : endLength) : style === "gable" ? endLength : sourceLimit;

	const loopStart = cfg.isSide ? (style === "gable" ? startLength : Math.round(startLength / 2)) : iVal;

	for (let i = loopStart; i <= newDataLength; i++) {
		if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
			LengthOptions[0].options.push({
				label: i,
				value: i
			});
		} else {
			LengthOptions[1].options.push({
				label: i,
				value: i
			});
		}
	}

	const_var[dimLength] = LengthOptions;

	const straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params[pitch], const_var.roofRegularDst);

	const dataH =
		style === "gable"
			? Math.floor(Math.min(params.p_h, params.p_h + ((params.p_w / 2) * params.p_r_p) / 12 - (params[width] * Number(params[pitch])) / 24))
			: Math.floor(params.p_h - (params[width] * Number(params[pitch])) / 12 - straightRoofval);

	const newDataH = style === "gable" ? dataH : parseInt(dataH) > maxHeight ? maxHeight : parseInt(dataH);

	for (let i = minHeight; i <= newDataH; i++) {
		const_var[dimHeight][i] = i;
	}

	if (params[height] > dataH) {
		params[height] = dataH < minHeight ? minHeight : dataH;

		cfg.updateLean();
	}

	if (style === "gable" && params[height] < minHeight) {
		params[height] = minHeight;

		cfg.updateLean();
	}

	// ORIGINAL FRONT/BACK LOGIC
	if (!cfg.isSide && params[height] > endLength && const_var[cfg.leanDataKey]?.building_structure) {
		params[height] = endLength;
	}

	const buildingMaxWidth = const_var.buildingWidthArray.find((s) => s.label === "Standard")?.options?.at(-1)?.value ?? params.p_w;

	const widthReference = cfg.isSide ? params.p_d : sourceLimit;

	const newDataWgable = Math.min(maxWidth, buildingMaxWidth, widthReference);

	if (newDataWgable < minWidth) {
		minWidth = newDataWgable;
	}

	const dataW = Math.floor((12 * (params.p_h - straightRoofval - params[height])) / params[pitch]);

	const newDataW = style === "gable" ? newDataWgable : parseInt(dataW) > maxWidth ? maxWidth : parseInt(dataW);

	for (let i = minWidth; i <= newDataW; i++) {
		const isStandard = (i - minWidth) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0;

		if (params.m_s_n == 100000 && params[width] != 14 && params[width] != 16) {
			if (i == 14 || i == 16) {
				continue;
			}
		}

		(isStandard ? WidthOptions[0] : WidthOptions[1]).options.push({
			label: i,
			value: i
		});
	}

	const_var[dimWidth] = WidthOptions;

	if (params[width] > newDataW && const_var[cfg.leanDataKey]?.building_structure) {
		params[width] = newDataW;
	}

	if (!params[cfg.addLeanKey]) {
		if (const_var[dimHeight].length == 0) {
			const_var[dimHeight][minHeight] = minHeight;
		}

		params[length] = sourceLimit;
		params[height] = const_var.b_m_i_hlean;
		params[width] = 12;

		if (const_var[dimWidth].length > 0 && const_var[dimWidth][0].options.length == 0 && const_var[dimWidth][1].options.length == 0) {
			const_var[dimWidth][0].options.push({
				label: minWidth,
				value: minWidth
			});

			params[width] = minWidth;
		}
	}

	if (Array.isArray(const_var[dimWidth])) {
		const_var[dimWidth] = const_var[dimWidth].filter((s) => {
			if (s.label === "Custom" && s.options.length === 0) {
				return false;
			}

			return true;
		});
	}
}

export function updateTemplateWidthL(state) {
	return updateTemplateWidthCommon("left");
}

export function updateTemplateWidthR(state) {
	return updateTemplateWidthCommon("right");
}

export function updateTemplateWidthF(state) {
	return updateTemplateWidthCommon("front");
}

export function updateTemplateWidthB(state) {
	return updateTemplateWidthCommon("back");
}
export const makeLeanDimension = (state, type) => {
	const config = {
		left: {
			prefix: "",
			side: "left",
			addLeanKey: "add_left_lean",
			widthKey: "lean_p_w",
			heightKey: "lean_p_h",
			depthKey: "lean_p_d",
			pitchKey: "b_l_t_r_p",
			doubleLegKey: "lean_p_e_l",

			lengthDimensionKey: "dimensionsLeanLD",
			widthDimensionKey: "dimensionsLeanLW",
			heightDimensionKey: "dimensionsLeanLH",

			removeIndex: 1,

			updateTemplate: updateTemplateWidthL,
			updateLean: cuBuilding.UpdateLeftLean,

			buildingUpdateKey: "addLeftLean",

			insulationKey: "leftLean",

			porchKeys: ["add_left_front_lean_porch", "add_left_back_lean_porch"],

			storageKey: "add_storage_check",

			openWalls: ["p_b_c_b_l_f", "p_b_c_b_l", "p_b_c_b_l_b"],

			doubleLegShowKey: "leanHasDoublelegshow",

			widthStart: 21,
			dimensionStart: 21
		},

		right: {
			prefix: "R",
			side: "right",
			addLeanKey: "add_right_lean",
			widthKey: "leanR_p_w",
			heightKey: "leanR_p_h",
			depthKey: "leanR_p_d",
			pitchKey: "b_l_t_r_pR",
			doubleLegKey: "leanR_p_e_l",

			lengthDimensionKey: "dimensionsLeanLDR",
			widthDimensionKey: "dimensionsLeanLWR",
			heightDimensionKey: "dimensionsLeanLHR",

			removeIndex: 2,

			updateTemplate: updateTemplateWidthR,
			updateLean: cuBuilding.UpdateRightLean,

			buildingUpdateKey: "addRightLean",

			insulationKey: "rightLean",

			porchKeys: ["add_right_front_lean_porch", "add_right_back_lean_porch"],

			storageKey: "add_storage_check_right",

			openWalls: ["p_b_c_b_r_f", "p_b_c_b_r", "p_b_c_b_r_b"],

			doubleLegShowKey: "leanRHasDoublelegshow",

			widthStart: 21,
			dimensionStart: 21
		},

		front: {
			prefix: "F",
			side: "front",
			addLeanKey: "add_front_lean",
			widthKey: "leanF_p_w",
			heightKey: "leanF_p_h",
			depthKey: "leanF_p_d",
			pitchKey: "b_l_t_r_pF",
			doubleLegKey: "leanF_p_e_l",

			lengthDimensionKey: "dimensionsLeanLDF",
			widthDimensionKey: "dimensionsLeanLWF",
			heightDimensionKey: "dimensionsLeanLHF",

			removeIndex: 3,

			updateTemplate: updateTemplateWidthF,
			updateLean: cuBuilding.UpdateFrontLean,

			buildingUpdateKey: "addFrontLean",

			insulationKey: "frontLean",

			porchKeys: ["add_left_front_lean_porch", "add_right_front_lean_porch"],

			storageKey: "add_storage_check_front",

			openWalls: ["p_b_c_b_f_f", "p_b_c_b_f_b", "p_b_c_b_f_l"],

			doubleLegShowKey: "leanFHasDoublelegshow",

			widthStart: 12,
			dimensionStart: 12
		},

		back: {
			prefix: "B",
			side: "back",
			addLeanKey: "add_back_lean",
			widthKey: "leanB_p_w",
			heightKey: "leanB_p_h",
			depthKey: "leanB_p_d",
			pitchKey: "b_l_t_r_pB",
			doubleLegKey: "leanB_p_e_l",

			lengthDimensionKey: "dimensionsLeanLDB",
			widthDimensionKey: "dimensionsLeanLWB",
			heightDimensionKey: "dimensionsLeanLHB",

			removeIndex: 4,

			updateTemplate: updateTemplateWidthB,
			updateLean: cuBuilding.UpdateBackLean,

			buildingUpdateKey: "addBackLean",

			insulationKey: "backLean",

			porchKeys: ["add_left_back_lean_porch", "add_right_back_lean_porch"],

			storageKey: "add_storage_check_back",

			openWalls: ["p_b_c_b_b_f", "p_b_c_b_b_b", "p_b_c_b_b_l"],

			doubleLegShowKey: "leanBHasDoublelegshow",

			widthStart: 12,
			dimensionStart: 12
		}
	};

	const cfg = config[type];

	const straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params[cfg.pitchKey], const_var.roofRegularDst);

	let calulateData = 6;
	let standradWidth = 6;

	const Lengthoptions = [
		{
			label: "Standard",
			options: []
		},
		{
			label: "Custom",
			options: []
		}
	];

	const Widthoptions = [
		{
			label: "Standard",
			options: []
		},
		{
			label: "Custom",
			options: []
		}
	];

	[12, 18, 24].forEach((size) => {
		if (state.params.p_h - (state.params[cfg.pitchKey] * size) / 12 >= state.const_var.b_m_i_hlean) {
			if (state.params.leanStyle[cfg.side] === "gable") {
				calulateData = Math.min(state.params.p_h, state.params.p_h + (state.params.p_w * state.params.p_r_p) / 24 - (state.params[cfg.widthKey] * state.params[cfg.pitchKey]) / 24);
			} else {
				calulateData = state.params.p_h - (state.params[cfg.pitchKey] * size) / 12;
			}

			standradWidth = size;
		}
	});

	if (const_var.BuildingLRoofPitch && Object.keys(const_var.BuildingLRoofPitch).length > 0) {
		let CheckVal = Math.round((state.params[cfg.widthKey] * Number(state.params[cfg.pitchKey])) / 12);

		let pitchArray = Object.values(const_var.BuildingLRoofPitch);

		let minPitch = Math.min(...pitchArray.map(Number));

		let checkCurrentMinHeight =
			state.params.leanStyle[cfg.side] === "gable"
				? state.params.p_h + (state.params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + Math.round((state.params[cfg.widthKey] * Number(state.params[cfg.pitchKey])) / 24) &&
					state.params[cfg.addLeanKey]
				: state.params.p_h - straightRoofval < state.const_var.b_m_i_hlean + CheckVal && state.params[cfg.addLeanKey];

		if (checkCurrentMinHeight && minPitch < Number(state.params[cfg.pitchKey])) {
			state.params[cfg.pitchKey] = minPitch.toString();
		}
	}

	let CheckVal = Math.round((state.params[cfg.widthKey] * Number(state.params[cfg.pitchKey])) / 12);

	if (
		(params.leanStyle[cfg.side] !== "gable" && state.params.p_h - straightRoofval < state.const_var.b_m_i_hlean + CheckVal && state.params[cfg.addLeanKey]) ||
		(params.leanStyle[cfg.side] === "gable" && state.params.p_h + (state.params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params[cfg.addLeanKey])
	) {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "YourCanNotAddLeanTo";

		state.params.add_full_lean_porch = false;

		const_var.UpdatedPriceData.right_wall_price_changed = true;

		const_var.UpdatedPriceData.left_wall_price_changed = true;

		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;

		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;

		if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) {
			const_var.UpdatedPriceData.height_price_changed = true;

			const_var.UpdatedPriceData.insulation_price = undefined;
		}

		state.params.p_l_b_l = true;
		state.params.p_r_b_l = true;

		state.params[cfg.widthKey] = 12;
		state.params[cfg.depthKey] = 21;

		state.params[cfg.heightKey] = state.const_var.b_m_i_hlean;

		state.params[cfg.pitchKey] = "2";

		cuBuilding.removeDataFromArray(cfg.removeIndex);

		const_var[cfg.doubleLegShowKey] = params[cfg.doubleLegKey] = false;

		params.insulation[cfg.insulationKey] = {
			showInsulation: false,
			isCheked: false,
			insulationId: 0,
			roofOnly: false,
			fullBuilding: false,
			showInsulationOptions: false,
			isDisableFullInsulation: false,
			custom: false
		};

		state.params.isShowCenter = false;

		state.params[cfg.addLeanKey] = false;

		state.params[cfg.storageKey] = false;

		cfg.porchKeys.forEach((key) => {
			state.params[key] = false;
		});

		cfg.openWalls.forEach((key) => {
			params[key] = "Open";
		});

		cuBuilding.BuildingUpdate(true, cfg.buildingUpdateKey);

		cfg.updateLean();


		onForceLeantoRemoval();

		cuBuilding.cP();

		params.activeWall = "c_b_f_w";

		const_var.wallSelection.centerBuildingWall = params.activeWall;

		const_var.wallSelection.leanToWall = "select";
	}

	let iVal = cfg.dimensionStart;

	const loopLimit = type === "left" || type === "right" ? params.p_d : params.p_w;

	if (loopLimit < cfg.dimensionStart) {
		iVal = loopLimit;

		if (iVal <= loopLimit) {
			const_var[cfg.lengthDimensionKey][iVal] = iVal;
		}
	}

	for (let i = iVal; i <= loopLimit; i++) {
		const_var[cfg.lengthDimensionKey][i] = i;
	}

	for (let i = iVal; i <= loopLimit; i++) {
		if ((i - iVal) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_length === 0) {
			Lengthoptions[0].options.push({
				label: i,
				value: i
			});
		} else {
			Lengthoptions[1].options.push({
				label: i,
				value: i
			});
		}
	}

	const_var[cfg.lengthDimensionKey] = Lengthoptions;

	for (let i = 6; i <= standradWidth; i++) {
		state.const_var[cfg.widthDimensionKey][i] = i;
	}

	for (let i = 6; i <= standradWidth; i++) {
		if ((i - 6) % const_var.roofObject[params.p_b_t][params.p_r_s].distance_on_width === 0) {
			if (params.m_s_n == 100000 && state.params[cfg.widthKey] != 14 && state.params[cfg.widthKey] != 16) {
				if (i == 14 || i == 16) {
					continue;
				}
			}

			Widthoptions[0].options.push({
				label: i,
				value: i
			});
		} else {
			if (params.m_s_n == 100000 && state.params[cfg.widthKey] != 14 && state.params[cfg.widthKey] != 16) {
				if (i == 14 || i == 16) {
					continue;
				}
			}

			Widthoptions[1].options.push({
				label: i,
				value: i
			});
		}
	}

	const_var[cfg.widthDimensionKey] = Widthoptions;

	for (let i = parseInt(state.const_var.b_m_i_hlean); i <= parseInt(calulateData); i++) {
		state.const_var[cfg.heightDimensionKey][i] = i;
	}

	if (calulateData < state.params[cfg.heightKey]) {
		if (state.const_var[cfg.heightDimensionKey][state.params[cfg.heightKey]] == undefined) {
			if (Math.floor(params.p_h - (state.params[cfg.widthKey] * state.params[cfg.pitchKey]) / 12) >= state.params[cfg.heightKey]) {
				state.params[cfg.heightKey] = params[cfg.heightKey];
			} else {
				state.params[cfg.heightKey] = calulateData;
			}
		}
	}

	cfg.updateTemplate();
};

export const makeDimensionUpdateLeft = (state) => {
	return makeLeanDimension(state, "left");
};

export const makeDimensionUpdateRight = (state) => {
	return makeLeanDimension(state, "right");
};

export const makeDimensionUpdateFront = (state) => {
	return makeLeanDimension(state, "front");
};

export const makeDimensionUpdateBack = (state) => {
	return makeLeanDimension(state, "back");
};
export const setPricingDataRightLeanto = (state, response, flag) => {
	return setPricingDataForLeanto(state, response, "addRightLean", flag);
};
export const setPricingDataLeftLeanto = (state, response, flag) => {
	return setPricingDataForLeanto(state, response, "addLeftLean", flag);
};
const setPricingDataFrontLeanto = (state, response, flag) => {
	return setPricingDataForLeanto(state, response, "addFrontLean", flag);
};
const setPricingDataBackLeanto = (state, response, flag) => {
	return setPricingDataForLeanto(state, response, "addBackLean", flag);
};
export const selectleanBuilding = (state, action, cuComponent) => {
	const_var.selectedLeanType = action.leanType;
	let notCheckForDefaultExtraAddOn = action.switchType != undefined ? action.switchType : false;
	if (action.leanType == "left") {
		const_var.a_p_d_a = const_var.leanGetDataLeft;
		if (params.leanStyle.left == "gable" && !notCheckForDefaultExtraAddOn) {
			checkRoofPitch(undefined, "left", const_var.leanGetDataLeft);
		}
		makeDimensionUpdateLeft(state);
		params.activeWall = "G_L_L_F_W";
		cuComponent.cameraFocusOnWall(state, "G_L_L_F_W");
	}
	if (action.leanType == "right") {
		const_var.a_p_d_a = const_var.leanGetDataRight;
		if (params.leanStyle.right == "gable" && !notCheckForDefaultExtraAddOn) {
			checkRoofPitch(undefined, "right", const_var.leanGetDataRight);
		}
		makeDimensionUpdateRight(state);
		params.activeWall = "G_R_L_F_W";
		cuComponent.cameraFocusOnWall(state, "G_R_L_F_W");
	}
	if (action.leanType == "front") {
		const_var.a_p_d_a = const_var.leanGetDataFront;
		if (params.leanStyle.front == "gable" && !notCheckForDefaultExtraAddOn) {
			checkRoofPitch(undefined, "front", const_var.leanGetDataFront);
		}
		makeDimensionUpdateFront(state);
		params.activeWall = "G_F_L_F_W";
		cuComponent.cameraFocusOnWall(state, "G_F_L_F_W");
	}
	if (action.leanType == "back") {
		const_var.a_p_d_a = const_var.leanGetDataBack;
		if (params.leanStyle.back == "gable" && !notCheckForDefaultExtraAddOn) {
			checkRoofPitch(undefined, "back", const_var.leanGetDataBack);
		}
		makeDimensionUpdateBack(state);
		params.activeWall = "G_B_L_F_W";
		cuComponent.cameraFocusOnWall(state, "G_B_L_F_W");
	}
	utils.updateCPAccordingToLNTBuilding();
	utils.restoreUpdatedPriceDataElements();
	const_var.isCBSelected = false;
	return {
		...state,
		newColor: action.leanType,
		action: action + const_var.a_p_d_a + Math.random()
	};
};
export const selectTrussForLean = (state, action, cuBuilding) => {
	state.params.l_t_p[action.leanType].trussId = action.truss.id;
	state.params.l_t_p[action.leanType].truss = action.truss;
	state.params.l_t_p[action.leanType].trussName = action.truss?.name?.replace(/[0-9]/g, "");

	state.const_var.post_data.building.leanto.forEach((lean) => {
		if (LEAN_TYPE_NUM_TO_STR[lean.leanto_type] === action.leanType) {
			lean.truss = action.truss;
			if (action.leanType === "left") {
				const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
				cuBuilding.cPforLLeanOnly();
			}
			if (action.leanType === "right") {
				const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
				cuBuilding.cPforRLeanOnly();
			}
			if (action.leanType === "front") {
				const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
				cuBuilding.cPforFLeanOnly();
			}
			if (action.leanType === "back") {
				const_var.UpdatedPriceData.backLean_truss_price_changed = true;
				cuBuilding.cPforBLeanOnly();
			}
		}
	});
	cuBuilding.BuildingUpdate(true, "");
	cuBuilding.cP();

	return {
		...state,
		newColor: action.value + const_var.post_data["building"].edit_truss_name + new Date()
	};
};
